import { Helmet } from 'react-helmet';
import QuoteForm from '../components/quote/QuoteForm';

const QuotePage = () => {
  return (
    <>
      <Helmet>
        <title>Request a Quote | VEDUS Supply Chain Management</title>
        <meta name="description" content="Request a customized quote for your domestic or international shipping needs. VEDUS offers logistics solutions via road, air, train, and ship transport." />
      </Helmet>
      
      <div className="bg-secondary-900 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-4">Request a Quote</h1>
          <p className="text-xl text-secondary-300 max-w-3xl mx-auto">
            Fill out the form below to get a customized quote for your shipping needs. Our team will respond promptly with competitive pricing and logistics solutions.
          </p>
        </div>
      </div>
      
      <div className="py-12 bg-secondary-50 dark:bg-secondary-800">
        <div className="container mx-auto px-4">
          <QuoteForm />
        </div>
      </div>
    </>
  );
};

export default QuotePage;